import { useAppSelector } from '../../../redux/hooks';
import useDefaultBuilderSchemaId from '../../../pages/Formulas/utils/useDefaultBuilderSchemaId';
import { useCurrentUrl } from '../../../utils/routing';
import useDashboardSchemaId from '../../../pages/DashboardRoute/utils/useDashboardSchemaId';
import { MaybeNil } from '../../../utils/interfaces';
import { activeSchemaIdSelector } from '../../../redux/selectors/builder';

/**
 * The schema is derived based on the page on which the dictionary is shown.
 *
 * Dashboard page:
 * Based on the analysis on the selected dashboard.
 * If the schema can not be derived (mixed schema dashboard)
 * it falls back to the default schema
 *
 * Reports and Cohorts:
 * Based on the selected schema in the builder itself
 */

export const useDictionarySchemaId = () => {
  let schemaId: MaybeNil<string>;

  const builderSchemaId = useAppSelector(activeSchemaIdSelector);

  const defaultBuilderSchemaId = useDefaultBuilderSchemaId();
  const dashboardSchemaId = useDashboardSchemaId();
  const { isDashboardInUrl, isCohortsInUrl, isReportInUrl } = useCurrentUrl();
  if (isDashboardInUrl) {
    schemaId = dashboardSchemaId;
  } else if (isCohortsInUrl || isReportInUrl) {
    schemaId = builderSchemaId;
  }
  return schemaId || defaultBuilderSchemaId;
};
